/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react"
import { verifyOTP, verifyOTPCorporate, verifyEmail, confirmEmail } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import Description from "../common/Description"
import TextInput from "../common/TextInput"
import BillingAccount from "./BillingAccount"
import SuccessScreen from "./SuccessScreen"
import ErrorAlert from "../common/ErrorAlert"
import AddLineDetails from "./AddLineDetails"
import getParameter from "../common/getParam"
import SpecificExceptions from "../../BackendServices/specific-exceptions"
import BackArrow from '../../assets/back-arrow.svg';

class EmailOTPVerify extends Component {
    state = {
        code: '',
        errors: { code: '' },
        errorType: { codeClassName: '' },
        formIsValid: false,
        isSuccess: false,
        billingNumbers: [],
        genericError: null,
        loading: false,
        isAddLineStep: false,
        minutes: 1,
        seconds: 0,
    }

    componentDidMount() {
        this.myInterval = setInterval(() => this.handleTicker(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
    }

    handleTicker = () => {
        const { seconds, minutes } = this.state;
        if (seconds > 0) {
            this.setState(({ seconds }) => ({
                seconds: seconds - 1,
            }));
        }
        if (seconds === 0) {
            if (minutes === 0) {
                clearInterval(this.myInterval);
            } else {
                this.setState(({ minutes }) => ({
                    minutes: minutes - 1,
                    seconds: 59,
                }));
            }
        }
    }

    handleValidation = async e => {
        e.persist();
        let errors = {};
        let errorType = {};
        let formIsValid = false;

        if (e.target.name === 'code') {
            if (e.target.value === null || e.target.value === '') {
                errors['code'] = "required";
                errorType['codeClassName'] = "validation-error"
            }
        }

        if ((JSON.stringify(errors) === '{}') && this.state.code !== '') {
            formIsValid = true
        }

        this.setState({
            formIsValid: formIsValid,
            errors: errors,
            errorType
        });

    }

    handaleSubmit = async (e) => {
        e.preventDefault();
        const { userName, hashCode } = this.props;
        this.setState({
            loading: true,
        })
        const data = {
            userName,
            hashCode,
            otp: this.state.code
        }

        const result = await confirmEmail(data);
        if (result.status.code === 'MAPI-000') {
            this.setState({
                loading: false,
                errors: { code: '' },
                errorType: {codeClassName: ""},
                code: ''
            })
            const acc_type = getParameter('account_type');
            window.location.href = acc_type === "auctions" ? this.props.redirectURL + "&reg=yes" : this.props.redirectURL;
        } else {
            this.setState({
                loading: false,
                code: '',
                errorType: {codeClassName: "api-error"},
                errors: { code: window['lang'] === 'en' ? result.status.englishDetail : result.status.arabicDetail }
            })
        }
    }

    verifyOTP = async (e) => {
        let requestBody = {
            "transactionId": this.props.transactionId,
            "verificationCode": this.state.code
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await verifyOTP(requestBody)
            this.setState({
                isSuccess: true,
                loginUrl: result.loginUrl,
                loading: false
            })
        } catch (error) {
            if (error instanceof SpecificExceptions && error.code === 'MAPI-024') {
                this.setState({
                    isAddLineStep: true,
                    loading: false
                })
            } else {
                this.setState({
                    genericError: error.message,
                    loading: false
                })
            }
        }
    }

    verifyOTPCorporate = async (e) => {
        let requestBody = {
            "transactionId": this.props.transactionId,
            "verificationCode": this.state.code
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await verifyOTPCorporate(requestBody)
            this.setState({
                transactionId: result.transactionId,
                isSuccess: true,
                billingNumbers: result.billingNumbers,
                loading: false
            })
        } catch (error) {
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }

    handleChange = async e => {
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value,
        })

        this.handleValidation(e);
    }

    handleResendCode = async e => {
        const { userName } = this.props;
        this.setState({
            loading: true,
        })
        let result = await verifyEmail(userName)

        this.myInterval = setInterval(() => this.handleTicker(), 1000);
        this.props.updateCode(result.hashCode)
        this.setState({
            loading: false,
            code: '',
            hashCode: result.hashCode,
            formIsValid: false,
            seconds: 0,
            minutes: 1
        })
    }

    render() {
        const { t, userEmail } = this.props;
        const { minutes, seconds } = this.state;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}

                {!this.state.isSuccess && !this.state.isAddLineStep && (
                    <>
                        <div className="loginIntroTextContainer">
                            <a className="emailRegBackButton" onClick={this.props.handleBack}>
                                <img src={BackArrow} alt='back' />
                            </a>
                            <h4>{t("verification_code")}</h4>
                            <p className="headerdescription">{`${t('code_desc')} ${userEmail} ${t('please_enter_text')}`}</p>
                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                {this.state.genericError && <ErrorAlert error={this.state.genericError} errorType={this.state.genericError ? "api-error" : ""}/>}
                                <form onSubmit={this.handaleSubmit} id={"verify-otp-form"}>
                                    <TextInput id={"activationCode"} className='verificationCode-text' label={t("enter_verification_code")} name={"code"} value={this.state.code} type={"text"} error={this.state.errors.code} errorType={this.state.errorType.codeClassName} handleChange={this.handleChange} />

                                    <div className='code-not-recieve'>
                                        {minutes === 0 && seconds === 0 ? (
                                            <p onClick={this.handleResendCode} id={"resendCode"}>{t('resend')}</p>
                                        ) : (
                                            <>
                                                <p>{t('didnt_recieve_code')}</p>
                                                <p>{t('recieve_new_code')} {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</p>
                                            </>
                                        )}
                                    </div>

                                    <div className="formButtonGroup activationcodeButton emailOtp-verification">
                                        <button id={"reg-verifyEmailButton"} type="submit" className="btn min_outlin_btn active" disabled={!this.state.formIsValid}>
                                            {t("verify_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
                }

                {
                    (this.state.isSuccess && this.props.from !== 'addLine') && (
                        <BillingAccount
                            redirectURL={this.props.redirectURL}
                            transactionId={this.props.transactionId}
                            billingNumbers={this.state.billingNumbers}
                            {...this.props}
                        />
                    )
                }

                {(this.state.isSuccess && this.props.from === 'addLine') && <SuccessScreen description={"enjoy_of_our_services"} loginUrl={this.state.loginUrl} />}

                {this.state.isAddLineStep && <AddLineDetails redirectURL={this.props.redirectURL} transactionId={this.props.transactionId} clientInfo={this.props.clientInfo} clientId={this.props.clientId} />}

            </>
        )
    }
}
export default withTranslation()(EmailOTPVerify);
